module.exports = __webpack_public_path__ + "static/media/one-core-tile-component.b8117c5d.mp4";